// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.paidPlanSubscription_container__K4xDy {
  width: 100%;
  min-height: 100vh;
  background-color: #0d0e11;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  padding-bottom: 100px;
}
  /* overflow-x: hidden;
  overflow-y: auto;
} */

/* .container > *:not(.backgroundGlow) {
  position: relative;
  z-index: 1;
} */

/* .backgroundGlow {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
} */

/* .backgroundSvg {
  position: absolute;
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  height: 100%;
  min-width: 360px;
  min-height: 684px;
} */

/* Header Image Background */
.paidPlanSubscription_headerImageContainer__yEkwO {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 92px;
  z-index: 0;
  pointer-events: none;
  overflow: hidden;
}

.paidPlanSubscription_headerImage__jq4jp {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* Header Branding */
.paidPlanSubscription_headerBranding__AJLfP {
  position: absolute;
  top: 47px;
  left: 50%;
  transform: translateX(-50%);
  width: 132px;
  height: 36px;
  z-index: 1;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: flex-start;
  padding-left: 3px;
  box-sizing: border-box;
}

.paidPlanSubscription_headerBrandingBg__FNQZt {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  z-index: 0;
}

.paidPlanSubscription_headerBrandingText__BJIFo {
  position: relative;
  z-index: 1;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: normal;
  color: #000000;
  margin: 0;
  padding: 0;
  margin-top: 2px;
}

.paidPlanSubscription_headerBrandingUrl__cOmPR {
  position: relative;
  z-index: 1;
  font-family: 'Roboto', sans-serif;
  font-weight: 400;
  font-size: 10px;
  line-height: normal;
  color: #484848;
  margin: 0;
  padding: 0;
  margin-top: 2px;
}

.paidPlanSubscription_logoContainer__XLo69 {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  margin-top: 18px;
  margin-bottom: 0;
  flex-shrink: 0;
  padding: 0 16px;
  box-sizing: border-box;
}

.paidPlanSubscription_logoWrapper__1S9Sy {
  width: 88px;
  height: 88px;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.paidPlanSubscription_logo__q55nL {
  object-fit: contain;
}

.paidPlanSubscription_content__wNRZW {
  width: 100%;
  max-width: 360px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;
  box-sizing: border-box;
  margin-top: 16px;
  position: relative;
  z-index: 1;
}

.paidPlanSubscription_title__EnJSA {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 16px;
  font-style: normal;
  line-height: 20px;
  color: #f3f4f6;
  margin: 0;
  width: 100%;
  display: flex;
}

/* Plan Card */
.paidPlanSubscription_planCardWrapper__y1mHp {
  position: relative;
  border-radius: 16px;
  padding: 1px;
  background: linear-gradient(90deg, #d5982f 0%, #8a2c89 100%);
  width: 100%;
  align-self: stretch;
}

.paidPlanSubscription_planCard__\\+8CWe {
  display: flex;
  padding: 16px;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px;
  align-self: stretch;
  border-radius: 16px;
  border: 1px solid #8A2C89;
  background: linear-gradient(109deg, #3C2929 0%, #161B20 100%);
  text-align: center;
  width: 100%;
  box-sizing: border-box;
  overflow: visible;
}

.paidPlanSubscription_planHeader__V-Ohu {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  gap: 6px;
  overflow: visible;
  min-width: 0;
}

.paidPlanSubscription_priceContainer__hNP9g {
  display: flex;
  align-items: center;
  gap: 6px;
  flex: 1 1;
  min-width: 0;
  text-align: center;
  border-radius: 12px;
}

.paidPlanSubscription_actualPrice__MEcuq {
  min-width: 46px;
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 24px;
  background: linear-gradient(270deg, #FD82F8 0%, #FFD976 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
  display: flex;
  flex-direction: column;
  justify-content: center;
  overflow: visible;
}

.paidPlanSubscription_strikePrice__YPHPl {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #9396a3;
  text-decoration: line-through;
  white-space: nowrap;
  overflow: visible;
  flex-shrink: 0;
}

.paidPlanSubscription_perDayBadge__BOb6e {
  display: flex;
  padding: 4px 6px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  border-radius: 4px;
  background: #0D0E11;
  flex-shrink: 0;
}

.paidPlanSubscription_perDayText__JIK7J {
  text-align: center;
  font-family: 'Noto Sans', sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 600;
  line-height: 14px;
  background: linear-gradient(180deg, #d5982f 0%, #fdf59a 50%, #d5982f 100%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  white-space: nowrap;
}

.paidPlanSubscription_planFooter__qrTVV {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
}

.paidPlanSubscription_validityText__x7IUG {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #f3f4f6;
  white-space: nowrap;
}

.paidPlanSubscription_checkIcon__jxY5q {
  position: relative;
  width: 24px;
  height: 24px;
  flex-shrink: 0;
}

.paidPlanSubscription_checkIconImg__qrXNQ {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

/* Bottom Section - Social Proof and CTA */
.paidPlanSubscription_bottomSection__IOSkW {
  position: fixed;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 360px;
  z-index: 1002;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  padding: 12px 16px;
  box-sizing: border-box;
  background: linear-gradient(90deg, #0D0E11 0%, #2D1B00 50%, #0D0E11 100%);
}

.paidPlanSubscription_socialProof__1hG92 {
  display: flex;
  width: 100%;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  box-sizing: border-box;
}

.paidPlanSubscription_socialProofContent__rvIw3 {
  display: flex;
  gap: 4px;
  align-items: center;
  justify-content: center;
  line-height: 16px;
  font-size: 12px;
  text-align: center;
}

.paidPlanSubscription_socialProofNumber__kIO5\\+ {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 500;
  font-size: 12px;
  line-height: 16px;
  background: linear-gradient(90deg, #00D4FF 0%, #7B61FF 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  font-variation-settings: 'CTGR' 0, 'wdth' 100;
}

.paidPlanSubscription_socialProofText__TKBBM {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  color: #ffffff;
  font-variation-settings: 'CTGR' 0, 'wdth' 100;
}

.paidPlanSubscription_ctaWrapper__G\\+LZ3 {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.paidPlanSubscription_ctaButton__AVNOb {
  display: flex;
  width: 100%;
  padding: 0 24px;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  gap: 12px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  min-height: 56px;
  border-radius: 16px;
  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);
  color: #0d0e11;
  max-width: 100%;
  box-sizing: border-box;
}

.paidPlanSubscription_upiGroupIcon__6LSnP {
  width: 68px;
  height: 28px;
  flex-shrink: 0;
  object-fit: contain;
}

.paidPlanSubscription_ctaButton__AVNOb:hover {
  opacity: 0.9;
}

.paidPlanSubscription_ctaButton__AVNOb:active {
  opacity: 0.8;
}

.paidPlanSubscription_ctaButton__AVNOb:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.paidPlanSubscription_enterUpiButton__E4eaZ {
  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);
  border: 1px solid rgba(255, 255, 255, 0.80);
  border-radius: 16px;
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px 24px;
  gap: 8px;
  width: 100%;
  cursor: pointer;
  transition: opacity 0.2s;
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: #000;
  max-width: 100%;
  box-sizing: border-box;
}

.paidPlanSubscription_enterUpiButton__E4eaZ:hover {
  opacity: 0.9;
}

.paidPlanSubscription_enterUpiButton__E4eaZ:active {
  opacity: 0.8;
}

.paidPlanSubscription_enterUpiButton__E4eaZ:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.paidPlanSubscription_enterUpiButton__E4eaZ span {
  font-family: 'Noto Sans', sans-serif;
  font-weight: 600;
  font-size: 16px;
  line-height: 16px;
  color: #000;
}

/* Mobile responsiveness */
@media (max-width: 500px) {
  .paidPlanSubscription_container__K4xDy {
    max-width: 100vw;
  }

  .paidPlanSubscription_content__wNRZW {
    max-width: 100%;
  }

  .paidPlanSubscription_bottomSection__IOSkW {
    left: 0;
    right: 0;
    transform: none;
    max-width: 100%;
    width: 100%;
  }
}

`, "",{"version":3,"sources":["webpack://./src/components/pwatv/PaidPlanSubscription/paidPlanSubscription.module.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,iBAAiB;EACjB,yBAAyB;EACzB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;AACvB;EACE;;GAEC;;AAEH;;;GAGG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;;;GASG;;AAEH,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,UAAU;EACV,oBAAoB;EACpB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,kBAAkB;EAClB,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,YAAY;EACZ,YAAY;EACZ,UAAU;EACV,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,2BAA2B;EAC3B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,mBAAmB;EACnB,cAAc;EACd,SAAS;EACT,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;EACf,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,SAAS;EACT,WAAW;EACX,aAAa;AACf;;AAEA,cAAc;AACd;EACE,kBAAkB;EAClB,mBAAmB;EACnB,YAAY;EACZ,4DAA4D;EAC5D,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,mBAAmB;EACnB,yBAAyB;EACzB,6DAA6D;EAC7D,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,QAAQ;EACR,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,SAAO;EACP,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,6DAA6D;EAC7D,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;EACnB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,oCAAoC;EACpC,eAAe;EACf,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,0EAA0E;EAC1E,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;EACpC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,cAAc;AAChB;;AAEA,0CAA0C;AAC1C;EACE,eAAe;EACf,SAAS;EACT,SAAS;EACT,2BAA2B;EAC3B,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,yEAAyE;AAC3E;;AAEA;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,4DAA4D;EAC5D,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,eAAe;EACf,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,0CAA0C;EAC1C,eAAe;EACf,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,gBAAgB;EAChB,mBAAmB;EACnB,+DAA+D;EAC/D,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,+DAA+D;EAC/D,2CAA2C;EAC3C,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,eAAe;EACf,wBAAwB;EACxB,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;EACpC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,OAAO;IACP,QAAQ;IACR,eAAe;IACf,eAAe;IACf,WAAW;EACb;AACF","sourcesContent":[".container {\n  width: 100%;\n  min-height: 100vh;\n  background-color: #0d0e11;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  padding-bottom: 100px;\n}\n  /* overflow-x: hidden;\n  overflow-y: auto;\n} */\n\n/* .container > *:not(.backgroundGlow) {\n  position: relative;\n  z-index: 1;\n} */\n\n/* .backgroundGlow {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n} */\n\n/* .backgroundSvg {\n  position: absolute;\n  top: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  height: 100%;\n  min-width: 360px;\n  min-height: 684px;\n} */\n\n/* Header Image Background */\n.headerImageContainer {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 92px;\n  z-index: 0;\n  pointer-events: none;\n  overflow: hidden;\n}\n\n.headerImage {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n/* Header Branding */\n.headerBranding {\n  position: absolute;\n  top: 47px;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 132px;\n  height: 36px;\n  z-index: 1;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  justify-content: flex-start;\n  padding-left: 3px;\n  box-sizing: border-box;\n}\n\n.headerBrandingBg {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background-color: #ffffff;\n  z-index: 0;\n}\n\n.headerBrandingText {\n  position: relative;\n  z-index: 1;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: normal;\n  color: #000000;\n  margin: 0;\n  padding: 0;\n  margin-top: 2px;\n}\n\n.headerBrandingUrl {\n  position: relative;\n  z-index: 1;\n  font-family: 'Roboto', sans-serif;\n  font-weight: 400;\n  font-size: 10px;\n  line-height: normal;\n  color: #484848;\n  margin: 0;\n  padding: 0;\n  margin-top: 2px;\n}\n\n.logoContainer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  margin-top: 18px;\n  margin-bottom: 0;\n  flex-shrink: 0;\n  padding: 0 16px;\n  box-sizing: border-box;\n}\n\n.logoWrapper {\n  width: 88px;\n  height: 88px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  overflow: hidden;\n}\n\n.logo {\n  object-fit: contain;\n}\n\n.content {\n  width: 100%;\n  max-width: 360px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  padding: 0 16px;\n  box-sizing: border-box;\n  margin-top: 16px;\n  position: relative;\n  z-index: 1;\n}\n\n.title {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  font-size: 16px;\n  font-style: normal;\n  line-height: 20px;\n  color: #f3f4f6;\n  margin: 0;\n  width: 100%;\n  display: flex;\n}\n\n/* Plan Card */\n.planCardWrapper {\n  position: relative;\n  border-radius: 16px;\n  padding: 1px;\n  background: linear-gradient(90deg, #d5982f 0%, #8a2c89 100%);\n  width: 100%;\n  align-self: stretch;\n}\n\n.planCard {\n  display: flex;\n  padding: 16px;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 10px;\n  align-self: stretch;\n  border-radius: 16px;\n  border: 1px solid #8A2C89;\n  background: linear-gradient(109deg, #3C2929 0%, #161B20 100%);\n  text-align: center;\n  width: 100%;\n  box-sizing: border-box;\n  overflow: visible;\n}\n\n.planHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n  gap: 6px;\n  overflow: visible;\n  min-width: 0;\n}\n\n.priceContainer {\n  display: flex;\n  align-items: center;\n  gap: 6px;\n  flex: 1;\n  min-width: 0;\n  text-align: center;\n  border-radius: 12px;\n}\n\n.actualPrice {\n  min-width: 46px;\n  text-align: center;\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 20px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 24px;\n  background: linear-gradient(270deg, #FD82F8 0%, #FFD976 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  white-space: nowrap;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  overflow: visible;\n}\n\n.strikePrice {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #9396a3;\n  text-decoration: line-through;\n  white-space: nowrap;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.perDayBadge {\n  display: flex;\n  padding: 4px 6px;\n  justify-content: center;\n  align-items: center;\n  gap: 10px;\n  border-radius: 4px;\n  background: #0D0E11;\n  flex-shrink: 0;\n}\n\n.perDayText {\n  text-align: center;\n  font-family: 'Noto Sans', sans-serif;\n  font-size: 14px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 14px;\n  background: linear-gradient(180deg, #d5982f 0%, #fdf59a 50%, #d5982f 100%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  white-space: nowrap;\n}\n\n.planFooter {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.validityText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 14px;\n  line-height: 20px;\n  color: #f3f4f6;\n  white-space: nowrap;\n}\n\n.checkIcon {\n  position: relative;\n  width: 24px;\n  height: 24px;\n  flex-shrink: 0;\n}\n\n.checkIconImg {\n  width: 100%;\n  height: 100%;\n  object-fit: contain;\n  display: block;\n}\n\n/* Bottom Section - Social Proof and CTA */\n.bottomSection {\n  position: fixed;\n  bottom: 0;\n  left: 50%;\n  transform: translateX(-50%);\n  width: 100%;\n  max-width: 360px;\n  z-index: 1002;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 12px;\n  padding: 12px 16px;\n  box-sizing: border-box;\n  background: linear-gradient(90deg, #0D0E11 0%, #2D1B00 50%, #0D0E11 100%);\n}\n\n.socialProof {\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  box-sizing: border-box;\n}\n\n.socialProofContent {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  justify-content: center;\n  line-height: 16px;\n  font-size: 12px;\n  text-align: center;\n}\n\n.socialProofNumber {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 500;\n  font-size: 12px;\n  line-height: 16px;\n  background: linear-gradient(90deg, #00D4FF 0%, #7B61FF 100%);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  font-variation-settings: 'CTGR' 0, 'wdth' 100;\n}\n\n.socialProofText {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 16px;\n  color: #ffffff;\n  font-variation-settings: 'CTGR' 0, 'wdth' 100;\n}\n\n.ctaWrapper {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.ctaButton {\n  display: flex;\n  width: 100%;\n  padding: 0 24px;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  gap: 12px;\n  border: 1px solid rgba(255, 255, 255, 0.8);\n  cursor: pointer;\n  transition: opacity 0.2s;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  min-height: 56px;\n  border-radius: 16px;\n  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);\n  color: #0d0e11;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.upiGroupIcon {\n  width: 68px;\n  height: 28px;\n  flex-shrink: 0;\n  object-fit: contain;\n}\n\n.ctaButton:hover {\n  opacity: 0.9;\n}\n\n.ctaButton:active {\n  opacity: 0.8;\n}\n\n.ctaButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.enterUpiButton {\n  background: linear-gradient(99deg, #00FF5E 0%, #00FFC3 101.74%);\n  border: 1px solid rgba(255, 255, 255, 0.80);\n  border-radius: 16px;\n  min-height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 16px 24px;\n  gap: 8px;\n  width: 100%;\n  cursor: pointer;\n  transition: opacity 0.2s;\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  color: #000;\n  max-width: 100%;\n  box-sizing: border-box;\n}\n\n.enterUpiButton:hover {\n  opacity: 0.9;\n}\n\n.enterUpiButton:active {\n  opacity: 0.8;\n}\n\n.enterUpiButton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.enterUpiButton span {\n  font-family: 'Noto Sans', sans-serif;\n  font-weight: 600;\n  font-size: 16px;\n  line-height: 16px;\n  color: #000;\n}\n\n/* Mobile responsiveness */\n@media (max-width: 500px) {\n  .container {\n    max-width: 100vw;\n  }\n\n  .content {\n    max-width: 100%;\n  }\n\n  .bottomSection {\n    left: 0;\n    right: 0;\n    transform: none;\n    max-width: 100%;\n    width: 100%;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `paidPlanSubscription_container__K4xDy`,
	"headerImageContainer": `paidPlanSubscription_headerImageContainer__yEkwO`,
	"headerImage": `paidPlanSubscription_headerImage__jq4jp`,
	"headerBranding": `paidPlanSubscription_headerBranding__AJLfP`,
	"headerBrandingBg": `paidPlanSubscription_headerBrandingBg__FNQZt`,
	"headerBrandingText": `paidPlanSubscription_headerBrandingText__BJIFo`,
	"headerBrandingUrl": `paidPlanSubscription_headerBrandingUrl__cOmPR`,
	"logoContainer": `paidPlanSubscription_logoContainer__XLo69`,
	"logoWrapper": `paidPlanSubscription_logoWrapper__1S9Sy`,
	"logo": `paidPlanSubscription_logo__q55nL`,
	"content": `paidPlanSubscription_content__wNRZW`,
	"title": `paidPlanSubscription_title__EnJSA`,
	"planCardWrapper": `paidPlanSubscription_planCardWrapper__y1mHp`,
	"planCard": `paidPlanSubscription_planCard__+8CWe`,
	"planHeader": `paidPlanSubscription_planHeader__V-Ohu`,
	"priceContainer": `paidPlanSubscription_priceContainer__hNP9g`,
	"actualPrice": `paidPlanSubscription_actualPrice__MEcuq`,
	"strikePrice": `paidPlanSubscription_strikePrice__YPHPl`,
	"perDayBadge": `paidPlanSubscription_perDayBadge__BOb6e`,
	"perDayText": `paidPlanSubscription_perDayText__JIK7J`,
	"planFooter": `paidPlanSubscription_planFooter__qrTVV`,
	"validityText": `paidPlanSubscription_validityText__x7IUG`,
	"checkIcon": `paidPlanSubscription_checkIcon__jxY5q`,
	"checkIconImg": `paidPlanSubscription_checkIconImg__qrXNQ`,
	"bottomSection": `paidPlanSubscription_bottomSection__IOSkW`,
	"socialProof": `paidPlanSubscription_socialProof__1hG92`,
	"socialProofContent": `paidPlanSubscription_socialProofContent__rvIw3`,
	"socialProofNumber": `paidPlanSubscription_socialProofNumber__kIO5+`,
	"socialProofText": `paidPlanSubscription_socialProofText__TKBBM`,
	"ctaWrapper": `paidPlanSubscription_ctaWrapper__G+LZ3`,
	"ctaButton": `paidPlanSubscription_ctaButton__AVNOb`,
	"upiGroupIcon": `paidPlanSubscription_upiGroupIcon__6LSnP`,
	"enterUpiButton": `paidPlanSubscription_enterUpiButton__E4eaZ`
};
export default ___CSS_LOADER_EXPORT___;
